export default __webpack_public_path__ + "static/media/Notifying_Icon.b2aa5d50.svg";